module.exports = __webpack_public_path__ + "6aeb0ba551ec4831e0f774bb6cf62788.fbx";